import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import Header from "../PackageInfo/Header";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import bb1 from "../../Images/Bhimashankar/bb1.jpg";
import bb2 from "../../Images/Bhimashankar/bb2.jpg";
import bb3 from "../../Images/Bhimashankar/bb3.jpg";
import bb4 from "../../Images/Bhimashankar/bb4.jpg";
import bb5 from "../../Images/Bhimashankar/bb5.JPG";

import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";

const itinerary = [
  {
    day: "Day 1",
    subheading: "Overnight journey to the fort base",
    schedule: [
      { time: "10:30 PM", activity: "Pick-up at Hadapsar." },
      { time: "10:55 PM", activity: "Pick-up at Swargate." },
      { time: "11:20 PM", activity: "Pick-up at Vanaz Metro Station." },
      { time: "11:45 PM", activity: "Pick-up at Wakad / Hinjwadi." },
      {
        time: "12:00 AM",
        activity:
          "Continue the overnight ride toward the Harichandragad base region.",
      },
    ],
    meals: ["Dinner / Light snacks on the way"],
    notes: [
      "Pickup points are fixed and alternate stops are not available.",
      "The overnight travel may vary slightly depending on the group schedule and traffic conditions.",
    ],
  },
  {
    day: "Day 2",
    subheading: "Fort climb, sunrise, and return",
    schedule: [
      {
        time: "05:00 AM",
        activity:
          "Reach the base village and freshen up after the overnight journey.",
      },
      {
        time: "06:00 AM",
        activity:
          "Enjoy breakfast and brief on the trek route and safety instructions.",
      },
      {
        time: "07:00 AM",
        activity: "Start the trek toward Harichandragad Fort.",
      },
      {
        time: "09:30 AM",
        activity:
          "Reach the fort plateau and explore the historic structures and viewpoints.",
      },
      {
        time: "11:00 AM",
        activity:
          "Enjoy the panoramic views of the surrounding Sahyadri range and valley.",
      },
      {
        time: "12:30 PM",
        activity:
          "Have lunch at the base village or fort area depending on the route conditions.",
      },
      {
        time: "02:00 PM",
        activity: "Begin the descent and relax before the return journey.",
      },
      {
        time: "04:00 PM",
        activity: "Start the return journey to Pune.",
      },
      { time: "09:30 PM", activity: "Approximate arrival back in Pune." },
    ],
    meals: ["Breakfast", "Lunch"],
    notes: [
      "The fort trek involves steep sections and rocky patches, so please move carefully and follow the lead.",
      "Weather and trail conditions may slightly affect the exact timing.",
    ],
  },
];

const trekMeta = {
  inclusions: [
    "🚌 Pune to Pune Travel by Non-AC Bus",
    "🍽️ Breakfast & Tea",
    "🥘 Delicious Veg Lunch",
    "🩺 Basic First Aid & Hydration Powder",
    "🧭 Experienced Trek Lead & Guide",
    "🌿 Entry charges and local coordination",
  ],
  exclusions: [
    'Any other charges not mentioned in "Inclusions"',
    "Mineral water, cold drinks, personal food, and extra snacks",
    "Personal expenses, insurance, or any additional activity costs",
  ],
  verticalCards: [
    { title: "Harichandragad", image: bb1 },
    { title: "Fort Views", image: bb2 },
    { title: "Trail Route", image: bb3 },
    { title: "Rocky Terrain", image: bb4 },
    { title: "Sahyadri Beauty", image: bb5 },
  ],
  trekData: [
    {
      name: "Harichandragad Fort",
      image: bb5,
      info: "Harichandragad Fort is one of the most iconic fort treks in the Sahyadris, known for its strong historical value, massive fort walls, and impressive viewpoints. Located in the Ahmednagar district, this trek offers a rewarding climb through rocky patches, forest trails, and scenic valley views. The sunrise from the fort is breathtaking, and the surrounding landscape is filled with mist, cliffs, and a peaceful mountain atmosphere. It is a perfect choice for trekkers who love a strong mix of history, adventure, and panoramic Sahyadri beauty.",
    },
  ],
  faq: [
    {
      question: "Where is Harichandragad located?",
      answer:
        "Harichandragad is located in the Ahmednagar district of Maharashtra, in the western Sahyadris.",
    },
    {
      question: "What is the difficulty level of the trek?",
      answer:
        "The trek is moderate to challenging, with a mix of steep climbs, rocky terrain, and scenic trails. Good fitness is recommended.",
    },
    {
      question: "Is this trek suitable for beginners?",
      answer:
        "It is suitable for trekkers with a reasonable fitness level and basic hiking experience. Beginners can join if they are comfortable with rocky ascent sections.",
    },
    {
      question: "Do we have guides on the trek?",
      answer:
        "Yes, experienced trek leaders and local guides accompany the group throughout the route for safety and navigation.",
    },
    {
      question: "Are meals included?",
      answer:
        "Yes, breakfast and lunch are included in the itinerary, along with tea and hydration support.",
    },
    {
      question: "What are the pickup points?",
      answer:
        "Pickup points usually include Hadapsar, Swargate, Vanaz Metro Station, and Wakad or Hinjwadi depending on the route.",
    },
    {
      question: "Is there mobile network coverage on the trail?",
      answer:
        "Signal can be weak in some sections, so it is advised to inform family or friends before starting the trek.",
    },
    {
      question: "What should I carry?",
      answer:
        "Carry a backpack, water bottle, light snacks, rain cover, trekking shoes, a cap, and personal medicines. A light extra layer is useful in the early morning. ",
    },
  ],
};

const Harichandragad = () => {
  return (
    <div className="bg-gray-50">
      <Header trekData={trekMeta.trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Harichandragad Fort"
          location="Ahmednagar, Maharashtra"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={itinerary} />
      <ImageCardsWithVerticalView verticalCards={trekMeta.verticalCards} />
      <ModalTriggerList
        inclusions={trekMeta.inclusions}
        exclusions={trekMeta.exclusions}
        type="trek"
        faq={trekMeta.faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default Harichandragad;
